module.exports = __webpack_public_path__ + "img/menu_safe.298eb995.svg";